export default {
  ITEM: 'item',
  PACKAGE: 'package',
  LOCATION: 'location',
  TAG: 'tag',
  ITEM_AVAILABILITY: 'itemAvailability',
  PACKAGE_AVAILABILITY: 'packageAvailability'
};
